module.exports = __webpack_public_path__ + "static/media/close-box-red.91bebd82.svg";